export const FIELD_ID = 'id';
export const FIELD_FIO = 'fio';
export const FIELD_EMAIL = 'email';
export const FIELD_PHONE = 'phone';
export const FIELD_CLIENT = 'clientId';
export const FIELD_MAIN = 'main';
